import React from 'react';
import ImageLightbox from './ImageLightbox';

const screenshotUrl = (file) => `${process.env.PUBLIC_URL}/screenshots/${file}`;

const ScreenshotCard = ({ file, title, description, wide = false }) => {
  const src = screenshotUrl(file);

  return (
    <div className={`relative group ${wide ? 'md:col-span-2' : ''}`}>
      <div className="absolute -inset-1 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-lg blur opacity-25 group-hover:opacity-40 transition duration-300" />
      <div className="relative bg-gradient-to-br from-cyan-950/50 to-blue-950/30 border border-cyan-500/30 rounded-lg overflow-hidden flex flex-col h-full">
        <div className="p-4 pb-0">
          <ImageLightbox src={src} alt={title}>
            <div className="relative rounded-md overflow-hidden border border-cyan-500/20 shadow-2xl">
              <img
                src={src}
                alt={title}
                loading="lazy"
                className={`w-full h-auto transform group-hover:scale-[1.02] transition duration-500 ${
                  wide ? '' : 'max-h-[480px] object-cover object-top'
                }`}
              />
            </div>
          </ImageLightbox>
        </div>
        <div className="p-6">
          <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
          <p className="text-gray-400 text-sm">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ScreenshotCard;
